module.exports = __webpack_public_path__ + "img/route.56d04808.png";